export default {
  BASE_URL: '/sys/app',
  api: [
    {
      name: 'list',
      desc: '获取应用列表',
      method: 'GET',
      path: 'list'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/app/index.js